/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
	type BaseResponse,
	BaseResponseFromJSON,
	BaseResponseToJSON,
} from '../models/BaseResponse';
import {
	type DocumentAddCommandResult,
	DocumentAddCommandResultFromJSON,
	DocumentAddCommandResultToJSON,
} from '../models/DocumentAddCommandResult';
import {
	type PutDocumentRequest,
	PutDocumentRequestFromJSON,
	PutDocumentRequestToJSON,
} from '../models/PutDocumentRequest';

export interface ApiV2DocumentDeleteRequest {
	caseId: string;
	documentId: string;
}

export interface ApiV2DocumentPutRequest {
	caseId: string;
	putDocumentRequest: PutDocumentRequest;
}

/**
 *
 */
export class DocumentApi extends runtime.BaseAPI {
	/**
	 * Creates request options for apiV2DocumentDelete without sending the request
	 */
	async apiV2DocumentDeleteRequestOpts(
		requestParameters: ApiV2DocumentDeleteRequest
	): Promise<runtime.RequestOpts> {
		if (requestParameters['caseId'] == null) {
			throw new runtime.RequiredError(
				'caseId',
				'Required parameter "caseId" was null or undefined when calling apiV2DocumentDelete().'
			);
		}

		if (requestParameters['documentId'] == null) {
			throw new runtime.RequiredError(
				'documentId',
				'Required parameter "documentId" was null or undefined when calling apiV2DocumentDelete().'
			);
		}

		const queryParameters: any = {};

		if (requestParameters['caseId'] != null) {
			queryParameters['caseId'] = requestParameters['caseId'];
		}

		if (requestParameters['documentId'] != null) {
			queryParameters['documentId'] = requestParameters['documentId'];
		}

		const headerParameters: runtime.HTTPHeaders = {};

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken('Bearer', []);
		}

		let urlPath = `/api/v2/document`;

		return {
			path: urlPath,
			method: 'DELETE',
			headers: headerParameters,
			query: queryParameters,
		};
	}

	/**
	 */
	async apiV2DocumentDeleteRaw(
		requestParameters: ApiV2DocumentDeleteRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<void>> {
		const requestOptions = await this.apiV2DocumentDeleteRequestOpts(requestParameters);
		const response = await this.request(requestOptions, initOverrides);

		return new runtime.VoidApiResponse(response);
	}

	/**
	 */
	async apiV2DocumentDelete(
		requestParameters: ApiV2DocumentDeleteRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<void> {
		await this.apiV2DocumentDeleteRaw(requestParameters, initOverrides);
	}

	/**
	 * Creates request options for apiV2DocumentPut without sending the request
	 */
	async apiV2DocumentPutRequestOpts(
		requestParameters: ApiV2DocumentPutRequest
	): Promise<runtime.RequestOpts> {
		if (requestParameters['caseId'] == null) {
			throw new runtime.RequiredError(
				'caseId',
				'Required parameter "caseId" was null or undefined when calling apiV2DocumentPut().'
			);
		}

		if (requestParameters['putDocumentRequest'] == null) {
			throw new runtime.RequiredError(
				'putDocumentRequest',
				'Required parameter "putDocumentRequest" was null or undefined when calling apiV2DocumentPut().'
			);
		}

		const queryParameters: any = {};

		if (requestParameters['caseId'] != null) {
			queryParameters['caseId'] = requestParameters['caseId'];
		}

		const headerParameters: runtime.HTTPHeaders = {};

		headerParameters['Content-Type'] = 'application/json';

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken('Bearer', []);
		}

		let urlPath = `/api/v2/document`;

		return {
			path: urlPath,
			method: 'PUT',
			headers: headerParameters,
			query: queryParameters,
			body: PutDocumentRequestToJSON(requestParameters['putDocumentRequest']),
		};
	}

	/**
	 */
	async apiV2DocumentPutRaw(
		requestParameters: ApiV2DocumentPutRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<DocumentAddCommandResult>> {
		const requestOptions = await this.apiV2DocumentPutRequestOpts(requestParameters);
		const response = await this.request(requestOptions, initOverrides);

		return new runtime.JSONApiResponse(response, (jsonValue) =>
			DocumentAddCommandResultFromJSON(jsonValue)
		);
	}

	/**
	 */
	async apiV2DocumentPut(
		requestParameters: ApiV2DocumentPutRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<DocumentAddCommandResult> {
		const response = await this.apiV2DocumentPutRaw(requestParameters, initOverrides);
		return await response.value();
	}
}
